/**
 * One hand-written `GET /api/invite/:token/identity` payload.
 *
 * Exists so /lab/pack can render the invite's welcome-pack section with no
 * backend, no database and no live site — the fields are copied verbatim from
 * a real deployed bundle's `_source/business.json` + `theme.json`, including
 * the `establishedIsEstimate: true` that the honest-age rule has to drop.
 *
 * Only the lab imports it, so it never reaches the invite bundle.
 */

import type { SiteIdentity } from './identity';

export const SAMPLE_PACK_IDENTITY: SiteIdentity = {
  slug: 'republic-plumbing-madison',
  domain: 'republic-plumbing-madison.foundlio.com',
  business: {
    name: 'Republic Plumbing',
    phone: '(615) 865-3005',
    city: 'Madison',
    state: 'TN',
    vertical: 'plumbing',
    // Guessed by the generator — the card must not print "Est. 2016".
    established: 2016,
    establishedIsEstimate: true,
    logo: 'https://img.foundlio.com/image/upload/v1787159907/foundlio/leads/logos/republic-plumbing-madison-nobg-1787159905694.png',
  },
  theme: {
    colors: 'crimson-bold',
    fonts: 'tech',
    logoFont: 'Space Grotesk',
    logoIsLogomark: false,
  },
};
